// Copyright Square, Inc.
import { CUSTOMER_DATA_FRAMEWORK } from "../CustomerDataFramework.js";
/**
 * @see MarketingUtmCarouselSwipeSlideEvent
 */
export var MarketingUtmCarouselSwipeSlide = function () { return ({
    name: "MarketingUtmCarousel Swipe Slide",
    parameters: {
        cdf_entity: "MarketingUtmCarousel",
        cdf_action: "Swipe",
    }
}); };
/**
 * @see MarketingUtmCarouselClickTitleEvent
 */
export var MarketingUtmCarouselClickTitle = function (_a) {
    var slideName = _a.slideName;
    return ({
        name: "MarketingUtmCarousel Click Title",
        parameters: {
            cdf_entity: "MarketingUtmCarousel",
            cdf_action: "Click",
            slide_name: slideName !== undefined && slideName !== null ? slideName.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see MarketingUtmCarouselClickNavButtonEvent
 */
export var MarketingUtmCarouselClickNavButton = function (_a) {
    var direction = _a.direction;
    return ({
        name: "MarketingUtmCarousel Click NavButton",
        parameters: {
            cdf_entity: "MarketingUtmCarousel",
            cdf_action: "Click",
            direction: direction !== undefined && direction !== null ? direction.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
